module.exports = __webpack_public_path__ + "static/media/help-white.c95f4f49.svg";